import Vue from "vue";

export default {
    install () {
        Vue.prototype.$getManufactureTitle = function(item) {
            if (item.requestMethod == 2) {
                return item.requestTitle + (item.orderUnit ? (' - ' + item.orderUnit.name) : '')
            } else {
                return item.designRequest.requestTitle + (item.designRequest.orderUnit ? (' - ' + item.designRequest.orderUnit.name) : '')
            }
        };

        Vue.prototype.$getManufactureRequestTitle = function(item) {
            if (item.requestMethod == 2) {
                return item.requestTitle;
            } else {
                return item.designRequest.requestTitle;
            }
        };
    },
};